module.exports = __webpack_public_path__ + "static/0010-aa8c21fd226de57b7d2ef37f9ca45620.png";